import React, { useEffect, useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { InfoBadge, TextLarge } from '@hz-design-system/web-ui';
import { TListingClient } from 'types/TListing';
import getDealerHighlights from '../../../repositories/getDealerHighlights';

import Classes from './Highlights.module.scss';

type THighlightsProps = {
  itemId: TListingClient['itemId'];
};

type TListingHighlight = { content: string };

const Highlights = ({ itemId }: THighlightsProps) => {
  const { t } = useI18nContext();
  const [highlights, setHighlights] = useState<TListingHighlight[]>([]);

  useEffect(() => {
    const fetchHighlights = async () => {
      const data: TListingHighlight[] = await getDealerHighlights({ adId: itemId });

      if (data) {
        setHighlights(data);
      }
    };

    fetchHighlights();
  }, [itemId]);

  if (highlights.length === 0) {
    return null;
  }

  return (
    <section className={Classes.root}>
      <TextLarge strong className={Classes.title}>
        {t('dealerHighlights.title')}
      </TextLarge>
      <ul className={Classes.list}>
        {highlights.map((highlight, index) => (
          <li key={index} className={Classes.item}>
            <InfoBadge>{highlight.content}</InfoBadge>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default Highlights;
